import {
	Backdrop,
	Box,
	Button,
	CircularProgress,
	IconButton,
	Paper,
	Tab,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tabs,
	Theme,
	Typography
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import clsx from "clsx";
import { observer } from "mobx-react";
import { ReactComponent as PageUpIcon } from '@common/images//PageUpIcon.svg';
import { ReactComponent as ScanToggleIcon } from '@common/images//ScanToggleIcon.svg';
import { ReactComponent as TableListOrder } from '@common/images//TableListOrder.svg';
import useNaviCustom from "@hooks/useNaviCustom";
import { addNcodeLayerToAllPages } from "../../../ndp/NdpPdfPrinter";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { AssignmentProjectMainStyle } from "@styles/assignments/AssignmentProjectMainStyle";

import { useTranslation } from 'react-i18next';
import { ProjectUserSortColumn } from "@stores/enums/ProjectStoreEnums";
import { getSemesterTypeString } from "@views/shared/functions/getSemesterTypeString";
// import { AnswerTab } from "./AnswerTab";
// import { PlanTab } from "./PlanTab";
import { ProjectUserTableRow } from "./ProjectUserTableRow";
import DownloadIcon from "@common/images/downloadIcon.png";

// import { RubricTab } from "./RubricTab";
import React from "react";
import { useParams } from "react-router-dom";
import { useStores } from '@hooks/useStores';
import { IProject, IProjectPropertyReader } from "@repositories/model/IProject";
import { ProjectStateType } from "@repositories/model/support/ProjectStateType";
import { AnswerTab } from "@views/shared/tabs/AnswerTab";
import { QuestionAndReferenceTab } from "@views/shared/tabs/QuestionAndReferenceTab";
import { RubricTab } from "@views/shared/tabs/RubricTab";
import { AssignmentCurriculumInfo } from "./AssignmentCurriculumInfo";
import { useNeoConfirm } from "@hooks/useNeoConfirm";
import { codeUtil } from "@util/codeUtil";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { QuestionsPDFGenerator } from "@views/assignments/create/QuestionsPDFGenerator";
import AssignedStudentsNameProvider from "@/common/objects/AssignedStudentsNameProvider";
import { USBAssignedUserMapper } from "@/common/objects/USBAssignedUserMapping/USBAssignedUserMapper";

type Props = {
}

function AssignmentProjectMain(props: Props) {
	const { navigateStore, projectStore, projectRagStore, projectExamStore, projectRubricStore, ncodeAllocationStore, authStore, projectSubmissionStore } = useStores();

	const params = useParams();
	const i18next = useTranslation();
	const classes = useEmotionStyles(AssignmentProjectMainStyle);

	const basicInfoRef = React.useRef<HTMLElement>();
	const testTargetRef = React.useRef<HTMLElement>();
	const templateProjectRef = React.useRef<HTMLElement>();
	const questionRef = React.useRef();
	const goodAnswerRef = React.useRef();
	const rubricRef = React.useRef();

	const [tabIndex, setTabIndex] = React.useState(0);
	const [projectCode, setProjectCode] = React.useState("");
	const [menuAnchorEl] = React.useState(null);
	const [projectUserListOpenArrowRotated, setProjectUserListOpenArrowRotated] = React.useState(true);
	// const [projectUserListSortingArrowRotated, setProjectUserListSortingArrowRotated] = React.useState(true);// true : asc
	const [page, setPage] = React.useState(0);
	const [rowsPerPage] = React.useState(10);
	const [, setMenuItemAnchorEl] = React.useState(null);
	const [isSelectingAll, setIsSelectingAll] = React.useState(false);

	const [templateProject, setTemplateProject] = React.useState<IProject>(null);
	// const [isSelectingProjectRubricList, setIsSelectingProjectRubricList] = React.useState(false);
	const [unusualApproach, setUnusualApproach] = React.useState(false);

	const isMenuOpen = Boolean(menuAnchorEl);
	// const menuItemOpen = Boolean(menuItemAnchorEl);

	const { project, projectUsers } = projectStore;
	const {
		projectExamQuestionsList,
		questionListLenObjPerExam,
		projectRubricTransferList,
		questionKeyAndSelectedProjectRubricIdxMap,
	} = projectRubricStore;

	const naviCustom = useNaviCustom();
	const {alert, confirm} = useNeoConfirm();

	React.useEffect(() => {
		const currentProjectCode = params?.projectCode;
		if (!currentProjectCode || currentProjectCode === projectCode) return;
		// if (!currentProjectCode) return;
		setProjectCode(currentProjectCode);
	}, [params, projectCode]);

	React.useEffect(() => {
		if (!projectCode) return;
		projectStore.getProjectStates(projectCode);
		projectStore.downloadProjectInfoAndStore(projectCode);
		projectStore.getProjectUserTransfers(projectCode, []);
		projectExamStore.downloadProjectExamListAndStore(projectCode);
		projectRagStore.getProjectRag(projectCode);
		projectRubricStore.getProjectExamQuestions(projectCode)
		// .then(result => {
		//   if (!result) {
		//     setIsSelectingProjectRubricList(true);
		//     return;
		//   }
		//
		//   const promisesForProjectRubric = projectRubricStore.projectExamQuestionsList.map((question, idx) => {
		//     return projectRubricStore.getProjectRubricList(question.projectExamCode, question.projectExamQuestionNum, question.key)
		//   });
		//
		//   Promise.all(promisesForProjectRubric)
		//     .then(_ => {
		//       setIsSelectingProjectRubricList(true);
		//     })
		//     .catch(error => {
		//       messageStore.alert(i18next.t("데이터 조회 중 오류가 발생했습니다."));
		//     })
		// })

		setIsSelectingAll(true);

		if (projectCode) {
			projectStore.fetchProject(projectCode).then(prj => {
				if (prj.templateCode) {
					projectStore.fetchProject(prj.templateCode).then(template => {
						setTemplateProject(template);
					});
				}
			});
		}


		return () => {
			projectStore.init();
			projectExamStore.init();
			projectRagStore.init();
			projectRubricStore.init();
		}
	}, [projectCode, projectStore, projectExamStore, projectRagStore, projectRubricStore]);

	const processAboutNotSubmitted = React.useCallback(async () => {
		alert(i18next.t("비정상적인 접근입니다. 목록으로 이동합니다."))
			.then(_ => {
				naviCustom.go('/assignments', true);
				// props.navigate('/assignments', {replace: true});
			});
	}, [alert, i18next, naviCustom]);

	React.useEffect(() => {
		if (!isSelectingAll) return;

		if (
			!projectStore.isSelectingProjectInfo &&
			!projectStore.isSelectingProjectStates &&
			!projectStore.isSelectingProjectUserTransfers &&
			!projectExamStore.isSelectingProjectExamList &&
			!projectRagStore.isSelectingProjectRag &&
			!projectRubricStore.isSelectingProjectExamQuestions
			// isSelectingProjectRubricList
		) {
			setIsSelectingAll(false);
			// setIsSelectingProjectRubricList(false);

			if (!project?.state || project?.state === ProjectStateType.CREATED) {
				setUnusualApproach(true);
				processAboutNotSubmitted();
			}
		}

	}, [
		isSelectingAll,
		projectStore.isSelectingProjectInfo,
		projectStore.isSelectingProjectStates,
		projectStore.isSelectingProjectUserTransfers,
		projectExamStore.isSelectingProjectExamList,
		projectRagStore.isSelectingProjectRag,
		projectRubricStore.isSelectingProjectExamQuestions,
		project?.state,
		processAboutNotSubmitted
		// isSelectingProjectRubricList
	]);

	const handleChangeTab = (event, newIndex) => {
		switch (newIndex) {
			case 0:
				basicInfoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
				break;
			case 1:
				testTargetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
				break;
			case 2:
				templateProjectRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
				break;
			/*
		case 1:
			questionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
			break;
		case 2:
			goodAnswerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
			break;
		case 3:
			rubricRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
			break;
			*/
		}

		setTabIndex(newIndex);
	};

	const handleClickScrollToTopBtn = () => {
		const projectTotalInfo = document.getElementById('projectTotalInfo');
		if (projectTotalInfo) {
			projectTotalInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	const handleClickProjectUserList = () => {
		setProjectUserListOpenArrowRotated(!projectUserListOpenArrowRotated);
	};


	// const currentSchoolLevelObj = React.useMemo(() => {
	// 	return SchoolLevelSubjects.find(school => school.name === project?.schoolType);
	// }, [project]);

	// const currentSubjectGroupObj = React.useMemo(() => {
	// 	if (!currentSchoolLevelObj) return;

	// 	return currentSchoolLevelObj.subjectGroups.find(group => group.name === project?.subject);
	// }, [project, currentSchoolLevelObj]);

	// const currentSubjectObj = React.useMemo(() => {
	// 	if (!currentSubjectGroupObj) return;

	// 	return currentSubjectGroupObj.subjects.find(subject => subject.name === project?.subjectName);
	// }, [project, currentSubjectGroupObj]);

	// const handleClickTemplateProjectInfo = () => {
	// 	if (!projectCode) return;

	// 	const code = project.templateCode ? project.templateCode : projectCode;
	// 	naviCustom.go(`/projects/${code}/create/view`);
	// 	// props.navigate(`/projects/${projectCode}/create/view`);
	// };

	const rowStartIdx = React.useMemo(() => {
		return page * rowsPerPage;
	}, [page, rowsPerPage]);

	const handleClickPage = (e, value) => {
		setPage(value - 1);
	};

	const projectUsersCount = React.useMemo(() => {
		if (!projectUsers) return 0;

		const totalCount = projectUsers?.length;

		return totalCount > 0
			? totalCount > rowsPerPage
				? Math.ceil(totalCount / rowsPerPage)
				: 1
			: 0
	}, [projectUsers, rowsPerPage]);

	const [sortStateMap, setSortStateMap] = React.useState({
		[ProjectUserSortColumn.NAME]: { sort: false },
		[ProjectUserSortColumn.SCHOOL]: { sort: false },
		[ProjectUserSortColumn.GRADE_CLASSNAME]: { sort: false },
	});

	const handleClickSort = (columnName) => {
		const sortState = sortStateMap[columnName];
		if (sortState) {
			sortState.sort = !sortState.sort;
			setSortStateMap({
				...sortStateMap,
				[columnName]: sortState,
			});

			projectStore.sortProjectUserTransfer(columnName, sortState.sort);
		}
	};

	const currentSemesterString = getSemesterTypeString(project?.year, project?.semesterType);

	const handleClickPrintBtn = (event) => {

		handleClickSmartPrint();
	};

	const handleClickQuestionsPrintBtn = (event) => {

		const pdfGenerator = new QuestionsPDFGenerator();
		pdfGenerator.generatePDF(projectCode);
	};

	const handleClickDownloadStudentNamesBtn = async (event) => {

		// 1. Load existing PDF
		const pdfUrl = `/pdf/ncode_sticker.pdf`;
		const existingPdfBytes = await fetch(pdfUrl).then(res => res.arrayBuffer());

		// 2. Load PDF into pdf-lib
		const pdfDoc = await PDFDocument.load(existingPdfBytes);

		// 3. Embed custom font (optional, fallback to StandardFonts if needed)
		const fontBytes = await fetch('/font/Pretendard-Light.ttf').then(res => res.arrayBuffer());
		pdfDoc.registerFontkit(fontkit); // only needed if using custom font
		const customFont = await pdfDoc.embedFont(fontBytes);

		// 4. Get the first page (or loop through pages if needed)
		const page = pdfDoc.getPage(0);
		// const pageWidth = page.getWidth();
		const pageHeight = page.getHeight();

		// 5. Sample names to write
		const provider = new AssignedStudentsNameProvider();
		const transfers = await provider.getStudentNames(projectCode);
		const userNames = transfers.map(t => t.name);
//		const userNames = [...duserNames, ...duserNames, ...duserNames];

		// 6. Draw names on the existing PDF
		const cols = 4;                     // 4 columns
		const cellWidth = 125;              // Width of each sticker cell
		const cellHeight = 62;              // Height of each sticker cell
		const marginLeft = 83;              // Left padding
		const initialOffsetY = 210;         // Top margin before first row starts
		const rowGap = 8.2;                   // Space between rows

		let x = marginLeft;
		let y = pageHeight - initialOffsetY;
		let col = 0;
		let row = 0;

		userNames.forEach((name, index) => {
			// Trim if too long
			let displayName = name;
			const maxTextWidth = cellWidth - 10;
			while (customFont.widthOfTextAtSize(displayName + '…', 12) > maxTextWidth && displayName.length > 0) {
				displayName = displayName.slice(0, -1);
			}
			if (displayName !== name) {
				displayName += '…';
			}

			// Calculate position
			x = marginLeft + col * cellWidth;
			y = pageHeight - initialOffsetY - row * (cellHeight + rowGap);

			const textWidth = customFont.widthOfTextAtSize(displayName, 12);
			const textX = x + (cellWidth - textWidth) / 2;
			const textY = y + (cellHeight / 2) - 6; // Adjust vertical centering

			// Draw text
			page.drawText(displayName, {
				x: textX,
				y: textY,
				font: customFont,
				size: 12,
				color: rgb(0, 0, 0),
			});
/*
			page.drawRectangle({
				x,
				y,
				width: cellWidth,
				height: cellHeight,
				borderColor: rgb(0, 0, 0),
				borderWidth: 0.5,
			});
*/
			// Advance grid
			col++;
			if (col >= cols) {
				col = 0;
				row++;
			}
		});

		// 7. Save and download
		const modifiedPdfBytes = await pdfDoc.save();
		const blob = new Blob([new Uint8Array(modifiedPdfBytes)], { type: 'application/pdf' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = 'user-names-annotated.pdf';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const handleClickDownloadUSBStudentAssignmentBtn = async (event) => {
		if (!projectCode) return;
		const mapper = new USBAssignedUserMapper();
		const pdf = await mapper.generatePDF(projectCode, project.name, project.curriculumYear);

		// 7. Save and download
		const url = pdf.pdfBlobURL;
		const link = document.createElement('a');
		link.href = url;
		link.download = 'usb-userlist.pdf';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}

	const handleMenuItemClose = () => {
		setMenuItemAnchorEl(null);
	};

	// const handleClickStandardPrint = async () => {
	// 	if (!projectCode) return;

	// 	window.open(`/projects/${projectCode}/create/printPaper`, '_blank');
	// 	// window.open(`/projects/${projectCode}/create/printAnswer`,'_blank');

	// 	handleMenuItemClose();
	// };

	const handleClickCancelBtn = async () => {
		const accepted = await confirm(i18next.t("제시 취소 시 이미 제출한 과제의 데이터는 모두 삭제되며 복구할 수 없습니다. 제시를 취소하시겠습니까?"));
		if (!accepted) {
			return;
		}

		const response = await projectStore.deleteSubmissionsFromProject(projectCode);

		if (response === true) {
			await projectStore.revertProjectStateBackToCreated(projectCode);
			await alert(i18next.t("취소되었습니다."));
		}

		// 리스트 페이지로 돌아가기
		naviCustom.go(`/assignments`, true);
	};

	// Helper to convert ArrayBuffer to base64
	// function arrayBufferToBase64(buffer: ArrayBuffer): string {
	// 	let binary = '';
	// 	const bytes = new Uint8Array(buffer);
	// 	const len = bytes.byteLength;
	// 	for (let i = 0; i < len; i++) {
	// 		binary += String.fromCharCode(bytes[i]);
	// 	}
	// 	return window.btoa(binary);
	// }

	async function handleClickSmartPrint() {
		let templateProject: IProject = null;
		if (project.templateCode) {
			templateProject = await projectStore.fetchProject(project.templateCode);
		}

		const { pdfBlobURL, pageCount } = await ncodeAllocationStore.addTextToPDF({
			project,
			templateProject,
			currentSemesterString,
			examList: projectExamStore.projectExamList,
			lang: navigateStore.language,
			teacher: authStore.loginUser
		});

		// 가장 최근에 allocation 된 것을 재활용한다.
		let ret = await ncodeAllocationStore.getProjectLastAllocation(projectCode, project.templateCode, pageCount);

		// allocation 된 것이 없으면 새로 할당한다.
		if (!ret) {
			ret = await ncodeAllocationStore.allocateCode(projectCode, project.templateCode, pageCount);
		}

		if (!ret) {
			await alert(i18next.t("스마트 페이퍼 구분을 위한 코드 할당에 실패했습니다. 서버 관리자에게 연락해 주십시오."));
			return;
		}

		console.log(`allocated code: ${ret.section}.${ret.startOwner}.${ret.startBook}.${ret.startPage} ~ ${ret.section}.${ret.endOwner}.${ret.endBook}.${ret.endPage}`);

		const pdfBytes = await addNcodeLayerToAllPages({
			ndpPdf: {
				section: 10,
				owner: ret.startOwner,
				bookCode: ret.startBook,
				pageStart: ret.startPage,
				pageEnd: ret.startPage + pageCount - 1
			}, fileUrl: pdfBlobURL
		});
		handleMenuItemClose();

		try {
			const blob = new Blob([new Uint8Array(pdfBytes)], { type: 'application/pdf' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = project.name + ".pdf"; // Set the filename
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		} catch (e) {
			console.error("PDF 다운로드 중 오류 발생:", e);
			await alert(i18next.t("PDF를 다운로드하는 중 오류가 발생했습니다."));
		}
/*
		// 이제 프린트한다
		let result = null;
		try {
			result = await NativeMethods.PrintPDFThroughAcrobatReader(project.name + ".pdf", pdfBytes);


			if (!result?.success) {
				let tryToInstall = false;
				if (!result || result?.errorCode === AcrobatReaderPrintErrorCode.AcrobatAppNotFound) {
					tryToInstall = await confirm(i18next.t("빠른 인쇄를 위한 Acrobat Reader가 설치되어 있지 않습니다. '확인'을 누르면 설치 페이지로 이동합니다. 설치 이후 다시 시도하면 빠른 인쇄를 경험하실 수 있습니다.\n\\n'취소'를 눌러' 설치하지 않으셔도 일반 인쇄를 통해 인쇄하실 수 있습니다."));
				}

				if (tryToInstall) {
					window.open('https://get.adobe.com/reader/', '_blank');
				}

				else {
					const blob = new Blob([pdfBytes], { type: 'application/pdf' });
					const url = URL.createObjectURL(blob);
					printJS(url);
				}
			}
		} catch (e) {
			if (!e.message || (e.message as string).search("Method not found") > -1) {
				await alert(i18next.t("NeoStudio2Lite 응응 프로그램이 설치되어 있지 않거나, 이전 버전의 응응 프로그램입니다. '확인'을 누르면 다운로드 페이지로 이동합니다."), i18next.t("다운로드 및 설치 필요"));

				window.open('/download', '_blank');
			}
		}
*/

	}

	if (unusualApproach) {
		return <></>;
	}

	const isNotSimpleModeAssignment = currentSemesterString.length > 1;

	// const renderSchoolTypeBox = () => {

	// 	let grade: string = "";
	// 	let result: string = "";
	//
	// 	// 2025.09.09
	// 	if (IProjectPropertyReader.isBefore027Ver(project)) {
	// 		const values = IProjectPropertyReader.before027VerCurriculumInfo(project);
	// 		grade = values[1];

	// 		result = codeUtil.mappedGradeStringAndSchoolString(grade)[1];
	// 	} else {
	// 		const values = IProjectPropertyReader.after027VerCurriculumInfo(project);

	// 		result = values[0];
	// 	}
	//
	//

	// 	return (
	// 		<Box className={classes.displayStyle}>
	// 			<Typography className={classes.basicTitle}>{i18next.t('학교급')}</Typography>
	// 			<Typography className={classes.basicText}>{result}</Typography>
	// 		</Box>
	// 	);
	// };

	const renderSchoolGradeSubjectBox = () => {

			let grade: string = "";
			// let schoolType: ProjectSchoolType = ProjectSchoolType.NOGRADE;
			let subject: string = "";
			let subjectRange: string = "";
			let secondRowText: string = "";
			let firstRowText: string = "";
			let thirdRowText: string = "";
			let fourthRowText: string = "";
			let fifthRowText: string = "";

			// 2025.09.09
			if (IProjectPropertyReader.isBefore027Ver(project)) {
				const values = IProjectPropertyReader.before027VerCurriculumInfo(project);
				// schoolType = values[0];
				grade = values[1];
				subject = values[2];
				subjectRange = values[3];

				const result = codeUtil.mappedGradeStringAndSchoolString(grade);
				const subjectText: string = subject;

				let subjectTranslatedText = codeUtil.translatedSubjectName(subjectText);
				secondRowText = `${result[0]} / ${subjectTranslatedText} / ${subjectRange ?? '-'}`;
				firstRowText = result[1];
				thirdRowText = "-";
				fourthRowText = "-";
				fifthRowText = "-";

			} else {
				const values = IProjectPropertyReader.after027VerCurriculumInfo(project);
				secondRowText = `${values[1]} / ${values[2]} / ${values[3] ?? '-'}`;
				firstRowText = `${values[0]}`;
				thirdRowText = values[4];
				fourthRowText = `[${values[5]}]`;
				fifthRowText = values[6];
			}

			console.log("📗 Grade/Subject:", secondRowText);

			return (
				<div>
					<Box className={classes.displayStyle}>
						<Typography className={classes.basicTitle2}>{i18next.t('학교급')}</Typography>
						<Typography className={classes.basicText2}>{firstRowText}</Typography>
					</Box>
					<Box className={classes.displayStyle}>
						<Typography className={classes.basicTitle2}>{i18next.t('학년/교과/과목')}</Typography>
						<Typography className={classes.basicText2}>{secondRowText}</Typography>
					</Box>
					<Box className={classes.displayStyle}>
						<Typography className={classes.basicTitle2}>{i18next.t('영역(단원)')}</Typography>
						<Typography className={classes.basicText2}>{thirdRowText}</Typography>
					</Box>
					<Box className={classes.displayStyle}>
						<Typography className={classes.basicTitle2}>{i18next.t('성취기준코드')}</Typography>
						<Typography className={classes.basicText2}>{fourthRowText}</Typography>
					</Box>
					<Box className={classes.displayStyle}>
						<Typography className={classes.basicTitle2}>{i18next.t('성취기준명')}</Typography>
						<Typography className={classes.basicText2}>{fifthRowText}</Typography>
					</Box>
				</div>
			);
		};




	return (
		<div className={classes.root}>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					background: '#F2F7F3',
					height: 'calc(100vh - 86px)'
				}}
				className={classes.padding}
			>
				<Box className={classes.mainContentBox}>
					<Box display='flex' alignItems='center' justifyContent='space-between' sx={{ marginBottom: "10px"}}>
						<Typography className={classes.previewText}>{i18next.t('평가과제운영 상세')}</Typography>

						{/* {!project?.includedOnline && projectStates?.submit && */}
						<Box display='flex' alignItems='center' sx={{ marginBottom: "20px" }}>
						<Button
							className={clsx(classes.cancelButton)}
							onClick={handleClickCancelBtn}
							disableRipple
							sx={{
							marginRight: "10px",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: "8px",
							backgroundColor: 'white',
							border: '1px solid #00966B',
							color: '#00966B',
							'&:hover': {
								backgroundColor: '#F2F7F3',
								border: '1px solid #00966B',
							}
							}}
						>
							<Typography sx={{ color: 'inherit' }}>{i18next.t('제시 취소')}</Typography>
						</Button>
						<Button
							className={clsx(classes.numberingExportBtn)}
							onClick={handleClickDownloadStudentNamesBtn}
							disableRipple
							sx={{
							marginRight: "10px",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: "8px",
							}}
						>
							<Typography>{i18next.t('스마트펜 번호표')}</Typography>
							<img style={{ width: 30, display: "block" }} src={DownloadIcon} alt="DownloadIcon" />
						</Button>
						{
						<Button
							className={clsx(classes.numberingExportBtn)}
							onClick={handleClickDownloadUSBStudentAssignmentBtn}
							disableRipple
							sx={{
							marginRight: "10px",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: "8px",
							}}
						>
							<Typography>{i18next.t('USB 번호표')}</Typography>
							<img style={{ width: 30, display: "block" }} src={DownloadIcon} alt="DownloadIcon" />
						</Button>
						}
						<Button
							className={clsx(classes.exportBtn)}
							onClick={handleClickQuestionsPrintBtn}
							disableRipple
							sx={{
							marginRight: "10px",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: "8px",
							}}
						>
							<Typography>{i18next.t('문제지')}</Typography>
							<img style={{ width: 30, display: "block" }} src={DownloadIcon} alt="DownloadIcon" />
						</Button>

						<Button
							className={clsx(classes.exportBtn)}
							onClick={handleClickPrintBtn}
							disableRipple
							sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: "8px",
							}}
						>
							<Typography>{i18next.t('답안지')}</Typography>
							<img style={{ width: 30, display: "block" }} src={DownloadIcon} alt="DownloadIcon" />
						</Button>
						</Box>

						{/* } */}
					</Box>

					<Tabs value={tabIndex} onChange={handleChangeTab} className={classes.trigger2}>
						<Tab value={0} label={i18next.t('평가과제 운영 정보')} disableRipple />
						<Tab value={1} label={i18next.t('평가 대상')} disableRipple />
						<Tab value={2} label={i18next.t('평가과제')} disableRipple />
					</Tabs>
					<div className={classes.root}>
						<Box className={classes.scrollBox}>

							<AssignmentCurriculumInfo
								project={project}
								templateProject={templateProject}
								basicInfoRef={basicInfoRef}
								isNotSimpleModeAssignment={isNotSimpleModeAssignment}
							/>

							<Box ref={testTargetRef} display='flex' alignItems='center'
								justifyContent='left'
								className={classes.commonTitleBox}>
								<Box>
									<Typography className={classes.commonSubTitle3} id={"projectTotalInfo"}>{i18next.t('평가 대상')} (<span style={{ color: '#008C73' }}>{projectUsers.length}</span>)</Typography>

								</Box>
							</Box>
							<Box className={classes.innerBox2}>
								<Box>

									<Box className={classes.searchName}>
										<Box display='flex' alignItems='center' justifyContent='left'
											className={classes.studentListView}
										>
											<Typography className={classes.basicTitle3}>{i18next.t("학생 목록 보기")}</Typography>
											<IconButton className={classes.iconBtnReset}
												onClick={handleClickProjectUserList}
												disableRipple
												id="basic-button"
												aria-controls={isMenuOpen ? 'basic-menu' : undefined}
												aria-haspopup="true"
												aria-expanded={isMenuOpen ? 'true' : undefined}>
												{/*<SchoolListIcon />*/}
												<ScanToggleIcon style={{ transform: !projectUserListOpenArrowRotated ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s ease' }} />
											</IconButton>
										</Box>
									</Box>

								</Box>
							</Box>

							{projectUserListOpenArrowRotated &&
								<Box>
									<TableContainer component={Paper} className={clsx(classes.tableBoxAssignment, classes.tableBox)}>
										<Table aria-label="simple table">
											<TableHead>
												<TableRow>
													<TableCell width='10%' className={classes.numberColumn}>{i18next.t('No.')}</TableCell>
													<TableCell width='15%'>
														<Box style={{ cursor: 'default' }} display='flex'
															onClick={() => handleClickSort(ProjectUserSortColumn.NAME)}>
															{i18next.t('이름')}
															<IconButton className={classes.iconBtnReset} style={{ transform: sortStateMap[ProjectUserSortColumn.NAME].sort ? 'none' : 'rotate(180deg)', transition: 'transform 0.3s ease' }} disableRipple>
																<TableListOrder />
															</IconButton>
														</Box>
													</TableCell>
													<TableCell width='29%' >{i18next.t('이메일')}</TableCell>
													<TableCell width='18%'>
														<Box style={{ cursor: 'default' }} display='flex'
															onClick={() => handleClickSort(ProjectUserSortColumn.SCHOOL)}>
															{i18next.t('학교')}
															<IconButton className={classes.iconBtnReset} style={{ transform: sortStateMap[ProjectUserSortColumn.SCHOOL].sort ? 'none' : 'rotate(180deg)', transition: 'transform 0.3s ease' }} disableRipple>
																<TableListOrder />
															</IconButton>
														</Box>
													</TableCell>
													<TableCell width='18%'>
														<Box style={{ cursor: 'default' }} display='flex'
															onClick={() => handleClickSort(ProjectUserSortColumn.GRADE_CLASSNAME)}>
															{i18next.t('학년반')}
															<IconButton className={classes.iconBtnReset} style={{ transform: sortStateMap[ProjectUserSortColumn.GRADE_CLASSNAME].sort ? 'none' : 'rotate(180deg)', transition: 'transform 0.3s ease' }} disableRipple>
																<TableListOrder />
															</IconButton>
														</Box>
													</TableCell>
													<TableCell width='18%' >{i18next.t('그룹')}</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{projectUsers && projectUsers
													.slice(rowStartIdx, rowStartIdx + rowsPerPage)
													.map((user, idx) => {
														return (
															<ProjectUserTableRow
																key={idx}
																idx={idx}
																rowStartNum={rowStartIdx + 1}
																user={user}
															/>
														)
													})
												}
											</TableBody>
										</Table>
									</TableContainer>
									<Box className={classes.pageNumber} display='flex' alignItems='center' justifyContent='center'>
										<Stack spacing={2}>
											<Pagination count={projectUsersCount}
												// page={page}
												onChange={handleClickPage}
												boundaryCount={2}
												showFirstButton
												showLastButton
												variant="outlined"
											/>
										</Stack>
									</Box>
								</Box>
							}

							{/* ================================================================================================ */}

							<Box ref={templateProjectRef} className={classes.title3Box}>
								<Typography className={classes.commonSubTitle3}>{i18next.t('평가 과제')}</Typography>
							</Box>
							{/* ---------------------------------------------------------------------------------- */}
							<Box>
								<Box className={classes.innerBox}>
									<Box display='flex' alignItems='center' justifyContent='left'>
										<Typography className={classes.commonSubTitle}>{i18next.t('과제 개요')}</Typography>
										{/*<IconButton className={clsx(classes.iconBtnReset, classes.editorIcon)} disableRipple>*/}
										{/*  <EditContainedIcon />*/}
										{/*</IconButton>*/}
									</Box>

									<Box className={classes.tabBox}>

										{renderSchoolGradeSubjectBox()}

									</Box>



									{/* ---------------------------------------------------------------------------------- */}


									{/* ---------------------------------------------------------------------------------- */}
									<Box className={clsx(classes.sectionTitle, classes.commonSubTitleBasicBox)}>
										<Typography className={classes.commonSubTitle} ref={questionRef}>{i18next.t('문항')}</Typography>
									</Box>

									{/*{(activeExam || activeRag) &&*/}


									<QuestionAndReferenceTab
										onClickScrollToTopBtn={handleClickScrollToTopBtn}
										projectExamList={projectExamStore.projectExamList}
										sideBarStepNum={navigateStore.sideBarMakeProjectStepNum}
										questionRef={questionRef}

										handleClickRagEdit={() => { }}
										handleClickQuestionEdit={() => { }}
										isQuestionNumberLabelVisible={false}
									/>
									{/*}*/}

									<Box className={clsx(classes.sectionTitle, classes.commonSubTitleBasicBox)}>
										<Typography className={classes.commonSubTitle} ref={goodAnswerRef}>{i18next.t('모범 답안')}</Typography>
										{/*{activeAnswer &&*/}
										{/*  <IconButton className={clsx(classes.iconBtnReset, classes.editorIcon)} disableRipple onClick={handleClickAnswerEdit}>*/}
										{/*    <EditContainedIcon />*/}
										{/*  </IconButton>*/}
										{/*}*/}
									</Box>

									{/*{ !isEmptyStage(TemplateProjectStateType.ANSWER) &&*/}
									{/*{activeAnswer &&*/}
									<AnswerTab projectExamList={projectExamStore.projectExamList} />
									{/*}*/}

									<Box className={clsx(classes.sectionTitle, classes.commonSubTitleBasicBox)}>
										<Typography className={classes.commonSubTitle} ref={rubricRef}>{i18next.t('평가 기준표')}</Typography>
										{/*{activeRubric &&*/}
										{/*  <IconButton className={clsx(classes.iconBtnReset, classes.editorIcon)} disableRipple onClick={handleClickRubricEdit}>*/}
										{/*    <EditContainedIcon />*/}
										{/*  </IconButton>*/}
										{/*}*/}
									</Box>

									{/*{ !isEmptyStage(TemplateProjectStateType.RUBRIC) &&*/}
									{/*{activeRubric &&*/}
									<RubricTab
										projectExamQuestionsList={projectExamQuestionsList}
										questionListLenObjPerExam={questionListLenObjPerExam}
										projectRubricTransferList={projectRubricTransferList}
										questionKeyAndSelectedProjectRubricIdxMap={questionKeyAndSelectedProjectRubricIdxMap}

									/>
									{/*}*/}
								</Box>
							</Box>
						</Box>
					</div>

					<IconButton
						className={classes.pageUpIcon}
						onClick={handleClickScrollToTopBtn}
						disableRipple>
						<PageUpIcon />
					</IconButton>

					{isSelectingAll &&
						<Backdrop
							sx={{ color: '#fff', zIndex: (theme) => (theme as Theme).zIndex.modal + 1 }}
							open={isSelectingAll}
						>
							<CircularProgress color="inherit" />
							<Typography style={{ color: '#fff' }}>&nbsp; {i18next.t('조회 중입니다...')}</Typography>
						</Backdrop>
					}

				</Box>
			</Box>
		</div>
	);
}

export default observer<typeof AssignmentProjectMain>(AssignmentProjectMain);
